import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import IconArrow from '../../assets/images/icon-arrow.svg';

type ProjectCardProps = {
  name: string;
  token: string;
  maxParticipants: number;
  remainingParticipants: number;
  onClick: (t: string) => void;
};

const ProjectCard = ({
  name,
  token,
  maxParticipants,
  remainingParticipants,
  onClick,
}: ProjectCardProps) => {
  const reportsCreated = maxParticipants - remainingParticipants;
  const {t} = useTranslation();

  return (
    <Container onClick={() => onClick(token)}>
      <Title>{name}</Title>
      <Rows>
        <Row>
          <span>{t('dashboard.credits')}</span>
          <span>{remainingParticipants}</span>
        </Row>
        <Row>
          <span>{t('dashboard.reports-created')}</span>
          <span>{reportsCreated}</span>
        </Row>
      </Rows>
      <Link>
        <span>{t('dashboard.go-to-project')}</span>
        <img src={IconArrow} alt="arrow" />
      </Link>
    </Container>
  );
};

export default ProjectCard;

const Container = styled.div`
  padding: 16px 24px;
  border-radius: 15px;
  border: solid 1px rgba(254, 103, 68, 0.2);
  cursor: pointer;
  transition: all ease-in-out 200ms;
  box-shadow: 0 10px 30px 0 rgba(254, 103, 68, 0.2);
  background-color: ${(p) => p.theme.colors.white};
  min-width: 250px;

  &:hover {
    box-shadow: 0 10px 30px 10px rgba(254, 103, 68, 0.2);
  }

  @media ${(props) => props.theme.breakpoints.phone} {
    width: 100%;
  }
`;

const Title = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 24px;
`;

const Link = styled.div`
  text-align: right;
  font-weight: 700;
  font-size: 16px;
  color: ${(p) => p.theme.colors.orange500};
  text-decoration: underline;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`;

const Rows = styled.div`
  margin-bottom: 24px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;

  span:nth-child(2) {
    font-weight: 700;
    font-size: 16px;
    color: ${(p) => p.theme.colors.violet500};
  }

  & + & {
    margin-top: 12px;
    padding-top: 12px;
    border-top: solid 1px ${(p) => p.theme.colors.gray200};
  }
`;
